/* unplugin-vue-components disabled */import { render } from "./Mv.vue?vue&type=template&id=643007b3&scoped=true"
import script from "./Mv.vue?vue&type=script&lang=js"
export * from "./Mv.vue?vue&type=script&lang=js"

import "./Mv.vue?vue&type=style&index=0&id=643007b3&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643007b3"]])

export default __exports__